module.exports = __webpack_public_path__ + "Employer Notice 08_16_2024.pdf";